<template>
    <!--
          作者：wangxw
          时间：2019-10-26
          描述：菜品分类管理
      -->
    <div class="product">
        <div class="baseInfo-left-base d-s-c">
<!--            <span class="name">{{ '菜品分类' }}</span>-->
            <div class="el-tabs-container">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane :label="$t('普通分类')" name="first">
                        <div class="common-level-rail">
                            <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus"
                                       v-auth="'/buildstore/index/index'">{{$t('添加分类')}}</el-button>
                        </div>
                        <!--内容-->
                        <div class="product-content">
                            <div class="table-wrap">
                                <el-table size="small" :data="tableData" row-key="category_id" default-expand-all
                                          :tree-props="{children: 'child'}" style="width: 100%" v-loading="loading">
                                    <el-table-column prop="name" :label="$t('分类名称')" width="180"></el-table-column>
                                    <el-table-column prop="" :label="$t('图片')" width="180">
                                        <template slot-scope="scope">
                                            <img v-img-url="hasImages(scope.row.images)" alt="" width="50px" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="sort" :label="$t('分类排序')"></el-table-column>
                                    <el-table-column prop="sort" :label="$t('状态')">
                                        <template slot-scope="scope">
                                            <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
                                                       @change="statusSet($event,scope.row.category_id)">
                                            </el-switch>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="create_time" :label="$t('添加时间')"></el-table-column>
                                    <el-table-column prop="lang" :label="$t('多语言翻译')" align="center">
                                        <template slot-scope="scope">
                                            <span class="lang-check" :class="[checkLanguage(scope.row.lang) ? 'el-icon-check' : 'el-icon-close']"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column fixed="right" :label="$t('操作')" width="100">
                                        <template slot-scope="scope">
                                            <div>
                                                <el-button @click="editClick(scope.row)" type="text" size="small">{{$t('编辑')}}</el-button>
                                                <el-button @click="deleteClick(scope.row)" type="text" size="small">{{$t('删除')}}</el-button>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('特色分类')" name="second">
                        <!--内容-->
                        <div class="product-content">
                            <div class="table-wrap">
                                <el-table size="small" :data="tableData" row-key="category_id" default-expand-all
                                          :tree-props="{children: 'child'}" style="width: 100%" v-loading="loading">
                                    <el-table-column prop="name" :label="$t('分类名称')" width="180"></el-table-column>
                                    <el-table-column prop="" :label="$t('图片')" width="180">
                                        <template slot-scope="scope">
                                            <img v-img-url="hasImages(scope.row.images)" alt="" width="50px" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="sort" :label="$t('分类排序')"></el-table-column>
                                    <el-table-column prop="sort" :label="$t('状态')">
                                        <template slot-scope="scope">
                                            <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
                                                       @change="statusSet($event,scope.row.category_id)">
                                            </el-switch>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="create_time" :label="$t('添加时间')"></el-table-column>
                                    <el-table-column prop="lang" :label="$t('多语言翻译')" align="center">
                                        <template slot-scope="scope">
                                            <span class="lang-check" :class="[checkLanguage(scope.row.lang) ? 'el-icon-check' : 'el-icon-close']"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column fixed="right" :label="$t('操作')" width="100">
                                        <template slot-scope="scope">
                                            <el-button @click="editClick(scope.row)" type="text" size="small"
                                                       v-auth="'/buildstore/index/index'">{{$t('编辑')}}</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-tab-pane>
<!--                    <el-tab-pane :label="$t('税率设置')" name="third">-->
<!--                    <div class="common-level-rail"><el-button size="small" type="primary" @click="addRateClick">{{$t('添加税率')}}</el-button></div>-->
<!--                    <div class="product-content">-->
<!--                      <div class="table-wrap">-->
<!--                        <el-table size="small" :data="taxTableData" default-expand-all-->
<!--                                  :tree-props="{children: 'child'}" style="width: 100%" v-loading="loading">-->
<!--                          <el-table-column prop="name" :label="$t('税率分类名称')" width="180"></el-table-column>-->
<!--                          <el-table-column prop="rate" :label="$t('税率')" width="180"></el-table-column>-->
<!--                          <el-table-column prop="category_id" :label="$t('适用于菜品分类')" width="180"></el-table-column>-->
<!--                          <el-table-column prop="create_time" :label="$t('添加时间')"></el-table-column>-->
<!--                          <el-table-column fixed="right" :label="$t('操作')" width="100">-->
<!--                            <template slot-scope="scope">-->
<!--                              <el-button @click="editTaxClick(scope.row)" type="text" size="small">{{$t('编辑')}}</el-button>-->
<!--                              <el-button @click="deleteTaxClick(scope.row)" type="text" size="small">{{$t('删除')}}</el-button>-->
<!--                            </template>-->
<!--                          </el-table-column>-->
<!--                        </el-table>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </el-tab-pane>-->
                </el-tabs>
            </div>
        </div>

        <!--添加菜品分类-->

        <!--添加-->
        <Add v-if="open_add" :open_add="open_add" :addform="categoryModel" @closeDialog="closeDialogFunc($event, 'add')">
        </Add>
        <!--修改-->
        <Edit v-if="open_edit" :open_edit="open_edit" :editform="categoryModel"
              @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

      <!--增加税率-->
<!--      <TaxRateAdd v-if="open_tax_add" :open_add="open_tax_add"  @closeTaxRateDialog="closeTaxRateDialogFunc($event, 'add')"></TaxRateAdd>-->
<!--      <TaxRateEdit v-if="open_tax_edit" :open_add="open_tax_edit" :editRateform="taxRateModel"  @closeTaxRateDialog="closeTaxRateDialogFunc($event, 'edit')"></TaxRateEdit>-->


    </div>
</template>

<script>
import {submitResEnum} from "@/logic/buildStore";
import PorductApi from '@/api/product.js';
import SupplierApi from '@/api/supplier.js';
import { checkLanguage } from '@/utils/base.js'

import Add from '@/components/buildStore/goods/classify/Add.vue';
import Edit from '@/components/buildStore/goods/classify/Edit.vue';
// import TaxRateAdd from '@/components/buildStore/goods/taxrate/Add.vue';
// import TaxRateEdit from '@/components/buildStore/goods/taxrate/Edit.vue';
export default {
    components: {
        Add,
        Edit,
        // TaxRateAdd,
        // TaxRateEdit
    },
    data() {
        return {
            /*是否加载完成*/
            loading: true,
            activeName: 'first',
            /*列表数据*/
            tableData: [],
            /*是否打开添加弹窗*/
            open_add: false,
            /*是否打开编辑弹窗*/
            open_edit: false,
            /*当前编辑的对象*/
            categoryModel: {
                catList: [],
                model: {}
            },
          taxTableData: [],
          taxRateModel:{},
          open_tax_add:false,
          open_tax_edit:false,
          storeList:[],
          languageFields :{
            "en": "english",
            "it": "italian",
            "de": "german",
            "es": "spanish",
            "fr": "french",
            "hr": "croatia",
            "sl": "slovenia",
            "hu": "hungarian"
          },
        };
    },
    created() {
        /*获取列表*/
        this.getData();
        SupplierApi.addGetTaxRate({}, true)
          .then(data => {
            this.storeList = data.data.storeList;
            console.log(this.storeList)
          })
          .catch(error => {});
    },
    methods: {
        // 多语言判断
        checkLanguage(lang){
            return checkLanguage(lang)
        },
        hasImages(e) {
            if (e) {
                return e.file_path;
            } else {
                return '';
            }
        },
        handleClick() {
            this.getData();
        },
        /*获取列表*/
        getData() {
            let self = this;
            self.loading = true;
            const langSelect = localStorage.getItem('lang-select');
            if (self.activeName == 'first') {
                PorductApi.storeCatList({}, true)
                    .then(data => {
                        self.loading = false;
                        self.tableData = data.data.list;
                        self.tableData.forEach(item => {
                          if (item.lang) {
                            const langInfo = JSON.parse(item.lang.category);
                            const langField = this.languageFields[langSelect];
                            if (langInfo[langField]) {
                              item.name = langInfo[langField];
                            }
                          }
                        });
                        self.categoryModel.catList = self.tableData;
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            }else if(self.activeName == 'second') {
                PorductApi.storeCatSP({}, true)
                    .then(data => {
                        self.loading = false;
                        self.tableData = data.data.list;
                        self.tableData.forEach(item => {
                          if (item.lang) {
                            const langInfo = JSON.parse(item.lang.category);
                            const langField = this.languageFields[langSelect];
                            if (langInfo[langField]) {
                              item.name = langInfo[langField];
                            }
                          }
                        });
                        self.categoryModel.catList = self.tableData;
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            }else{
              SupplierApi.getTaxRate({}, true)
                .then(data => {
                  self.loading = false;
                  let listData = data.data.list.data;

                  let categoryMap = {};
                  this.storeList.forEach(category => {
                    categoryMap[category.category_id] = category.name;
                  });

                  listData.forEach(item => {
                    if (Array.isArray(item.category_id)) {
                      let names = item.category_id.map(function(id){
                        return categoryMap[id];
                      });
                      item.category_id = names.join(',');
                    }
                  });
                  self.taxTableData = listData;
                })
                .catch(error => {
                  self.loading = false;
                });
            }

        },
        /*打开添加*/
        addClick() {
            this.open_add = true;
        },

        /*打开编辑*/
        editClick(item) {
            this.categoryModel.model = item;
            this.open_edit = true;
        },

        statusSet(e, id) {
            let self = this;
            PorductApi.storeCatSet({
                category_id: id,
                status: e
            }).then(data => {
                self.$message({
                    message: data.msg,
                    type: 'success'
                });
            });
        },

        /*关闭弹窗*/
        closeDialogFunc(e, f) {
            if (f == 'add') {
                this.open_add = e.openDialog;
                if (e.type == 'success') {
                    this.getData();
                }
            }
            if (f == 'edit') {
                this.open_edit = e.openDialog;
                if (e.type == 'success') {
                    this.getData();
                }
            }
        },
        /*删除分类*/
        deleteClick(row) {
            let self = this;
            self.$confirm(self.$t('删除后不可恢复，确认删除该记录吗?'), self.$t('提示'), {
                type: 'warning'
            }).then(() => {
                PorductApi.storeCatDel({
                    category_id: row.category_id
                }).then(data => {
                    self.$message({
                        message: self.$t('删除成功'),
                        type: 'success'
                    });
                    self.getData();
                });
            });
        },

        onSubmit() {
            return submitResEnum.success
        },

        addRateClick(){
          this.open_tax_add = true;
        },
        closeTaxRateDialogFunc(e, f) {
          if (f == 'add') {
            this.open_tax_add = e.openDialog;
            if (e.type == 'success') {
              this.activeName = 'third'
              this.getData();
            }
          }
          if (f == 'edit') {
            this.open_tax_edit = e.openDialog;
            if (e.type == 'success') {
              this.activeName = 'third'
              this.getData();
            }
          }
        },
        /*打开编辑*/
        editTaxClick(row) {
          this.taxRateModel = {}
          SupplierApi.getTaxRate({id:parseInt(row.id)}, true)
            .then(data => {
              if(data.data.list.data.length >0){
                this.taxRateModel = data.data.list.data[0];
                this.open_tax_edit = true;
              }else{
                alert(this.$t('未找到相应数据'))
              }
            })
            .catch(error => {});
        },
        deleteTaxClick(row) {
          let self = this;
          self.$confirm(self.$t('删除后不可恢复，确认删除该记录吗?'), self.$t('提示'), {
            type: 'warning'
          }).then(() => {
            SupplierApi.deleteTaxRate({
              id: row.id
            }).then(data => {
              self.$message({
                message: self.$t('删除成功'),
                type: 'success'
              });
              this.activeName = 'third'
              self.getData();
            });
          });
        },


    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/buildstore/goods/goodsClassify/index.vue